// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.round-modal-panel {
    box-sizing: border-box;
    width: min(16.8rem, 70.4vw);
    aspect-ratio: 1;
    padding: 1.75rem 1.5rem;
    background-color: var(--main-background-color);
    border: 0.4rem solid var(--main-foreground-color);
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.round-modal-panel .selectors {
    margin: 0;
}

.round-modal-panel .presets {
    align-items: flex-end;
    gap: 0.6rem;
    margin-bottom: 1.1rem;
}

.round-modal-panel .preset {
    box-sizing: border-box;
    width: 2.6rem;
    height: 2.6rem;
    padding: 0;
    margin-top: 1.1rem;
    font-size: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.1s, color 0.1s, margin-top 0.1s, width 0.1s, height 0.1s;
}

.round-modal-panel .preset.selected {
    width: 3.4rem;
    height: 3.4rem;
    margin-top: 0;
    font-size: 1.15rem;
}

.round-modal-panel .dose-stepper {
    margin-bottom: 0.75rem;
}

.round-modal-panel .confirm-dose {
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    color: var(--main-foreground-color);
    padding: 0.25rem;
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/RoundModal.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,eAAe;IACf,uBAAuB;IACvB,8CAA8C;IAC9C,iDAAiD;IACjD,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uFAAuF;AAC3F;;AAEA;IACI,aAAa;IACb,cAAc;IACd,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;IACZ,mCAAmC;IACnC,gBAAgB;IAChB,eAAe;AACnB","sourcesContent":[".round-modal-panel {\n    box-sizing: border-box;\n    width: min(16.8rem, 70.4vw);\n    aspect-ratio: 1;\n    padding: 1.75rem 1.5rem;\n    background-color: var(--main-background-color);\n    border: 0.4rem solid var(--main-foreground-color);\n    border-radius: 50%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.round-modal-panel .selectors {\n    margin: 0;\n}\n\n.round-modal-panel .presets {\n    align-items: flex-end;\n    gap: 0.6rem;\n    margin-bottom: 1.1rem;\n}\n\n.round-modal-panel .preset {\n    box-sizing: border-box;\n    width: 2.6rem;\n    height: 2.6rem;\n    padding: 0;\n    margin-top: 1.1rem;\n    font-size: 1rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background-color 0.1s, color 0.1s, margin-top 0.1s, width 0.1s, height 0.1s;\n}\n\n.round-modal-panel .preset.selected {\n    width: 3.4rem;\n    height: 3.4rem;\n    margin-top: 0;\n    font-size: 1.15rem;\n}\n\n.round-modal-panel .dose-stepper {\n    margin-bottom: 0.75rem;\n}\n\n.round-modal-panel .confirm-dose {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: none;\n    border: none;\n    color: var(--main-foreground-color);\n    padding: 0.25rem;\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
